import React, { useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, Filler);

// A single metric trend line over the selected range.
export default function TrendChart({ title, unit, points, metric, color = '#1e5c33' }) {
  const data = useMemo(() => {
    const labels = points.map((p) =>
      new Date(p.timestamp).toLocaleString('en-GB', {
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      })
    );
    return {
      labels,
      datasets: [
        {
          label: `${title} (${unit})`,
          data: points.map((p) => p[metric]),
          borderColor: color,
          backgroundColor: `${color}1a`,
          borderWidth: 2,
          pointRadius: 0,
          tension: 0.3,
          fill: true,
        },
      ],
    };
  }, [points, metric, title, unit, color]);

  const options = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      interaction: { mode: 'index', intersect: false },
      plugins: {
        legend: { display: false },
        tooltip: { callbacks: { label: (ctx) => ` ${ctx.parsed.y} ${unit}` } },
      },
      scales: {
        x: { ticks: { maxTicksLimit: 6, maxRotation: 0, font: { size: 10 } }, grid: { display: false } },
        y: { ticks: { font: { size: 10 } }, grid: { color: '#f1f5f9' } },
      },
    }),
    [unit]
  );

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 shadow-sm">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-sm font-semibold text-gray-700">{title}</h4>
        <span className="text-xs text-gray-400">{unit}</span>
      </div>
      <div style={{ height: 180 }}>
        {points.length ? (
          <Line data={data} options={options} />
        ) : (
          <div className="h-full flex items-center justify-center text-sm text-gray-400">
            No data for this range
          </div>
        )}
      </div>
    </div>
  );
}
